/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Link from 'material/ctas/link/link_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/signup/signup_styles';



/* ========== ~~~~~~~~~~ CTA : SIGN UP  : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const SignUpCTA = (props) => {
	return (
		<div className={`cta signupcta ${props.classes.signupcta}`}>
	        <p>Don't have an account yet? <Link type={`internal`} action={`auth/requestdemo`} text={`Request Demo`} /></p>
	    </div>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SignUpCTA);